import script from "./play.vue?vue&type=script&setup=true&lang=js"
export * from "./play.vue?vue&type=script&setup=true&lang=js"

import "./play.vue?vue&type=style&index=0&id=4f201790&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f201790"]])

export default __exports__